
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useConversationDetail } from "./hooks/useConversationDetail";
import ConversationLoadingState from "./ConversationLoadingState";
import ConversationEmptyState from "./ConversationEmptyState";
import ConversationTabsView from "./ConversationTabsView";
import { truncateId } from "./conversationUtils";
import { Badge } from "@/components/ui/badge";

interface ConversationDetailPanelProps {
  conversationId: string;
}

const ConversationDetailPanel = ({ conversationId }: ConversationDetailPanelProps) => {
  const {
    conversationDetails,
    isLoadingDetails,
    audioData,
    isLoadingAudio,
    currentTab,
    setCurrentTab,
    handleFetchAudio
  } = useConversationDetail({ conversationId });

  const renderContent = () => {
    if (isLoadingDetails) {
      return <ConversationLoadingState />;
    }

    if (!conversationDetails) {
      return <ConversationEmptyState />;
    }

    return (
      <ConversationTabsView
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        conversationDetails={conversationDetails}
        conversationId={conversationId}
        audioData={audioData}
        isLoadingAudio={isLoadingAudio}
        handleFetchAudio={handleFetchAudio}
      />
    );
  };

  return (
    <Card className="shadow-md">
      <CardHeader className="bg-card border-b">
        <div className="flex justify-between items-center">
          <CardTitle className="text-lg">
            Conversation Details
          </CardTitle>
          <Badge variant="outline" className="font-mono text-xs">
            {truncateId(conversationId)}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        {renderContent()}
      </CardContent>
    </Card>
  );
};

export default ConversationDetailPanel;
